import { gsap } from "gsap";
import scrollLock from 'scroll-lock';

export default {
	name: 'default',
	leave({ current, next, trigger }) {
		return new Promise(resolve => {
			gsap.to(current.container, {
				opacity: 0,
				ease: 'none',
				duration: 0.4,
				onComplete: function() {
					resolve();
				},
			});
		});
	},
	afterLeave({ current, next, trigger }) {
		gsap.set(next.container, {
			opacity: 0,
		});

		next.container.classList.add('default-transition-absolute');
        document.body.classList.remove('body--menu-sticky');
        document.body.classList.remove('body--menu-open');

        scrollLock.clearQueueScrollLocks();
        scrollLock.enablePageScroll();
	},
	enter({ current, next, trigger }) {
		return new Promise(resolve => {
			gsap.to(next.container, {
				opacity: 1,
				ease: 'none',
				duration: 0.6,
				onComplete: function() {
					resolve();
				},
			});
		});
	},
	after({ current, next, trigger }) {
		next.container.classList.remove('default-transition-absolute');
	},
};
